import { LeagueRewardsT } from '../../types';
import RocketIcon from '../../assets/svg/utils/rocket/rocket.svg';
import ChestRewardIco from '../../assets/images/chests/chest-with-treasure.png';
import Energy from '../../assets/svg/utils/energy/energy-ltr.svg';

export function EnergyReward({ energy }: LeagueRewardsT) {
  return (
    <div className="text-white mt-[0] text-base font-bold font-Bangers relative">
      <div className="absolute right-[1px] top-[-20px] translate-x-[8px]">
        <img src={Energy} alt="energy-icon" className="w-[38px]" />
        <div className={`absolute text-26 font-normal font-Bangers top-[20px] right-[15px] px-2
      text-transparent bg-clip-text bg-gradient-to-b from-[#FFE016] to-[#FFFFFF]
      `}
        >
          {energy}
        </div>
      </div>
      <div className="text-xs mt-6">
        Extra spins
      </div>
    </div>
  );
}
export function RocketCoinsYieldReward({ rocket_coins_recovery_per_hour: rocketCoinsPerHour }: LeagueRewardsT) {
  return (
    <div className="text-white mt-[0] text-base font-bold font-Bangers relative">
      <div className="absolute right-[5px] top-[-29px]">
        <div className="scale-x-[-1]">
          <img src={RocketIcon} alt="rocket-icon" className="w-[47px] translate-y-[10px]" />
        </div>
        <div className={`absolute text-26 font-normal font-Bangers top-[30px] right-[26px] px-2
      text-transparent bg-clip-text bg-gradient-to-b from-[#6064FF] to-[#FFFFFF]
      `}
        >
          {rocketCoinsPerHour}
        </div>
      </div>
      <div className="mt-6 text-xs tracking-[-0.6px]">
        multiplying  Rockets
      </div>
    </div>
  );
}

export function ChestReward({ chest }: { chest: LeagueRewardsT['launch_chest'] }) {
  return (
    <div className="text-white mt-[0] text-base font-bold font-Bangers relative">
      <div className="absolute right-[5px] top-[-29px]">
        <div className="scale-x-[-1]">
          <img src={ChestRewardIco} alt="ChestRewardIco" className="h-[40px] translate-y-[8px]" />
        </div>
        <div className={`absolute text-26 font-normal font-Bangers top-[30px] right-[26px] px-2
      text-transparent bg-clip-text bg-gradient-to-b from-[#6064FF] to-[#FFFFFF]
      `}
        >
          {chest}
        </div>
      </div>
      <div className="mt-6 text-xs">
        Orbit chest
      </div>
    </div>
  );
}
